import { render } from "./LineChart.vue?vue&type=template&id=0f81fada"
import script from "./LineChart.vue?vue&type=script&lang=js"
export * from "./LineChart.vue?vue&type=script&lang=js"
script.render = render

export default script